import React, { useEffect, useState } from "react";
import TablePagination from "@mui/material/TablePagination";
import Box from "@mui/material/Box";

const PaginationBar = (props) => {
  const {
    rowsPerPage: rowsPerPageProp,
    rowsPerPageOptions,
    count,
    onPageChange,
    onRowsChange,
    CurrentPage,
  } = props;

  const [rowsPerPage, setRowsPerPage] = useState(0);

  useEffect(() => {
    setRowsPerPage(rowsPerPageProp);
  }, [rowsPerPageProp]);

  const handleChangePage = (e, newPage) => {
    e.preventDefault();
    onPageChange?.(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    const value = parseInt(e.target.value, 10);
    onRowsChange?.(value);
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#000",

        /* 🔑 MAIN FIX */
        "& .MuiTablePagination-toolbar": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "16px",
          width: "100%",
        },

        /* ❌ REMOVE spacer */
        "& .MuiTablePagination-spacer": {
          display: "none",
        },

        /* 🔑 REMOVE auto-push to right */
        "& .MuiTablePagination-actions": {
          marginLeft: "0 !important",
        },

        /* 🔑 Normalize margins so items stay centered */
        "& .MuiTablePagination-selectLabel": {
          margin: 0,
          color: "#fff",
        },
        "& .MuiTablePagination-displayedRows": {
          margin: 0,
          color: "#fff",
        },

        /* White icons */
        "& .MuiSvgIcon-root": {
          color: "#fff",
        },
        "& .MuiSelect-icon": {
          color: "#fff",
        },
        "& .MuiInputBase-root": {
          color: "#fff",
        },
      }}
    >
      <TablePagination
        component="div"
        rowsPerPageOptions={rowsPerPageOptions}
        rowsPerPage={rowsPerPage}
        count={count}
        page={CurrentPage}
        labelRowsPerPage="Maximum rows per page"
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default PaginationBar;
